var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgramFestaTabT(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 60,
    viewBox: "0 0 122 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_524_14694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61 28L47 14L61 0L75 14L61 28ZM51.9475 14L61 23.0525L70.0525 14L61 4.94755L51.9475 14Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9999 19.8925L55.1074 13.9999L60.9999 8.10742L66.8925 13.9999L60.9999 19.8925ZM60.055 13.9999L60.9999 14.9449L61.9449 13.9999L60.9999 13.055L60.055 13.9999Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_524_14694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3216 37.3789H16.7244V58.6158H20.3216V37.3789Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1256 37.3789H26.5283V58.6158H30.1256V37.3789Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1035 45.6131L17.944 49.0576L19.1056 52.4406L29.2652 48.996L28.1035 45.6131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6361 37.4072H0V40.9817H12.6361V37.4072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.11948 39.1943H4.52222V58.5929H8.11948V39.1943Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1107 60L32.6151 47.2681L40.5291 36L43.4754 38.0426L37.0403 47.2057L45 57.8723L42.1107 60Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5553 45.4521H34.8306V49.0266H43.5553V45.4521Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_524_14694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.635 58.5776L113.226 43.4631L108.125 58.5492L104.737 57.4058L111.49 37.4503L112.981 37.4389L114.866 37.4219L122 57.3773L118.635 58.5776Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.856 52.3948L113.376 49.917L110.896 52.3948L113.376 54.8726L115.856 52.3948Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5755 59.1976H53V40.3855L61.7168 36.8018L63.0776 40.1011L56.5755 42.7747V59.1976Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.658 46.3124L54.0498 49.7559L55.5252 53.01L63.1334 49.5665L61.658 46.3124Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.111 59.414L79.9076 56.5981L84.9635 52.656L78.6095 44.9138L86.8651 36.4834L89.4215 38.9807L83.4092 45.1243L90.0535 53.2191L82.111 59.414Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.749 37.3535H92.1772V40.9259H104.749V37.3535Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.251 39.1396H96.6752V58.5433H100.251V39.1396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1002 60L64.6547 47.269L72.5231 36L75.4553 38.0422L69.0558 47.2064L76.9698 57.8725L74.1002 60Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.535 45.4541H66.858V49.0265H75.535V45.4541Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_524_14694"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(47)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_524_14694"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 24,
    fill: "white",
    transform: "translate(0 36)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_524_14694"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69,
    height: 24,
    fill: "white",
    transform: "translate(53 36)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramFestaTabT);
export default __webpack_public_path__ + "static/media/programFestaTabT.f258935d8bbae187e51f7baa49b2f6ad.svg";
export { ForwardRef as ReactComponent };